import { isValid, parse } from 'date-fns'
import React, { useState } from 'react'

import { IconButton } from 'components/uiKit/Button'
import type { IInputProps } from 'components/uiKit/Input'
import Input from 'components/uiKit/Input'
import { KitSize } from 'components/uiKit/KitTypes'

interface ICustomDatePickerInput extends Omit<IInputProps, 'name' | 'onChange'> {
  name?: string
  onChange?: (value: number | null) => void
}

const DatePickerInput = React.forwardRef<HTMLInputElement, ICustomDatePickerInput>(
  ({ value, error, onChange, disabled, name = 'dateInput', ...rest }, ref) => {
    const [validError, setValidError] = useState(false)

    const handleOnChange = (value?: string | null) => {
      const date = value?.length === 10 && parse(value, 'dd.MM.yyyy', new Date())
      if (!value) {
        setValidError(false)
        onChange?.(null)
      } else if (date && isValid(date)) {
        setValidError(false)
        onChange?.(date.getTime())
      } else {
        setValidError(true)
        onChange?.(null)
      }
    }

    const clearDate = (e: React.MouseEvent) => {
      e.stopPropagation()
      onChange?.(null)
    }

    return (
      <Input
        {...rest}
        autoComplete='off'
        disabled={disabled}
        error={validError || error}
        name={name}
        onChange={handleOnChange}
        postfix={
          <IconButton
            disabled={disabled}
            icon={value ? 'otherReset' : 'otherCalendar'}
            name={value ? 'reset' : 'calendar'}
            onClick={value ? clearDate : undefined}
            size={KitSize.S}
            styleType='ghost'
            type='button'
          />
        }
        ref={ref}
        value={value}
      />
    )
  },
)
DatePickerInput.displayName = 'DatePickerInput'

export default DatePickerInput
